















































import { Component, Vue, Prop, Watch } from "vue-property-decorator";
@Component({})
export default class XitongshujuList extends Vue {
  @Prop()
  private message: any;
  @Prop()
  private link: any;
  private data: any = {};

  @Watch("message", { immediate: true })
  private messageChange(msg) {
    if (msg && msg.title) {
      this.data = msg;
    }
  }
  private returnList() {
    this.$emit("returnList");
  }
}
